import React, { useEffect, useState } from "react";
import "./multi-select-filter-search.scss";
import {
  Button,
  Checkbox,
  Col,
  Drawer,
  Input,
  Popover,
  Row,
  Space,
  Spin,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export const MultiSelectFilterSearch = (props) => {
    
    useEffect(()=>{
        debugger;
        if(props.loading!==undefined){
            setLoading(props.loading);
        }
    },[props.loading])



  const { t } = useTranslation();
  const maxDisplayOptions = props.maxDisplayOptions || 5;
  const [selectedOptions, setSelectedOptions] = useState(
    props.initialValue?.length > 0 ? props.initialValue : []
  );
  const [loading,setLoading]=useState(props.loading?props.loading:false)
  const [remainCount, setRemainCount] = useState();
  const [isMoreOptionsDrawerOpen, setIsMoreOptionDrawerOption] = useState(false);

  console.log("sssrender component",selectedOptions);

  const getMoreFilterDisplayOptions = (val) => {
    if (props.options?.length > 0) {
      if (val !== "" && val !== undefined) {
        let options = props.options.filter(
          (z) => z.value?.toLowerCase()?.indexOf(val?.toLowerCase()) > -1
        );
        return options;
      } else {
        return props.options;
      }
    }
    return [];
  };

  const [moreFilterOptions, setMoreFilterOptions] = useState(
    getMoreFilterDisplayOptions()
  );
  //get display options
  const getDisplayOptions = (val) => {
    if (props.options?.length > 0) {
      if (val !== "" && val !== undefined) {
        let options = props.options.filter(
          (z) => z.value?.toLowerCase()?.indexOf(val?.toLowerCase()) > -1
        );
        options = options.filter((z, index) => {
          if (index < maxDisplayOptions) {
            return z;
          }
        });
        setRemainCount(props.options.length - options.length);
        return options;
      } else {
        let localDisplayOptions = [];
        if (selectedOptions.length > 0) {
          localDisplayOptions = props.options.filter((z, index) => {
            if (selectedOptions.includes(z.value)) {
              return z;
            }
          });
        }
        let localMaxDisplayOptions = maxDisplayOptions;
        if (localDisplayOptions.length < maxDisplayOptions) {
          localMaxDisplayOptions =
            maxDisplayOptions - localDisplayOptions.length;
        }
        //let localMaxDisplayOptions=localDisplayOptions?.length>0?localDisplayOptions?.length-maxDisplayOptions:maxDisplayOptions;

        let options = props.options.filter((z, index) => {
          if (
            localMaxDisplayOptions > 0 &&
            !selectedOptions.includes(z.value)
          ) {
            localMaxDisplayOptions--;
            return z;
          }
        });

        options = options.concat(localDisplayOptions);

        return options;
      }
    }
  };

  const [displayOptions, setDisplayOptions] = useState(getDisplayOptions());

  const [searchValue, setSearchValue] = useState("");
  const [moreFilterSearchValue, setMoreFilterSearchValue] = useState("");
  const handleSearchValue = (e) => {
    setSearchValue(e.target.value);
    setDisplayOptions(getDisplayOptions(e.target.value));
  };

  const handleOptionSelectionChange = (values) => {
    setSelectedOptions(values);
    props.onSelectionChange(values);
  };

  const handleMoreFilterSearchValue = (e) => {
    setMoreFilterSearchValue(e.target.value);
    setMoreFilterOptions(getMoreFilterDisplayOptions(e.target.value));
  };
  const handleMoreFilterOptionSelectionChange = (values) => {
    setSelectedOptions(values);
    props.onSelectionChange(values);
  };

  const containerStyle = {
    position: "relative",
    height: 200,
    padding: 10,
    overflowX: "scroll",
  };

  const moreFilterTitleContent = () => {
    return (
      <>
        <div className="more-drawer-header">
          <Space
            direction="horizontal"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Input.Search
              onChange={handleMoreFilterSearchValue}
              value={moreFilterSearchValue}
            ></Input.Search>
            <span
              onClick={() => setIsMoreOptionDrawerOption(false)}
              style={{ fontSize: "16px" }}
            >
              <CloseOutlined />
            </span>
          </Space>
        </div>
      </>
    );
  };

  const applyMoreFilter = () => {
    setIsMoreOptionDrawerOption(false);
    props.onMoreFilterApply();
  };

  const moreFilterContent = () => {
    return (
      <>
        <Space direction="vertical">
          <Checkbox.Group
            className="options-wrapper"
            onChange={handleMoreFilterOptionSelectionChange}
            value={selectedOptions}
          >
            <Row gutter={20}>
              {moreFilterOptions.map((z) => (
                <>
                  <Col sm={8}>
                    <Checkbox value={z.value}>{z.label}</Checkbox>
                  </Col>
                </>
              ))}
            </Row>
          </Checkbox.Group>
        </Space>
        <Space
          className="space horizontal-space"
          direction="horizontal"
          size="middle"
        >
          <Button
            type="default"
            onClick={() => {
              setIsMoreOptionDrawerOption(false);
            }}
          >
            {t("CANCEL")}
          </Button>
          <Button type="primary" onClick={applyMoreFilter}>
            {t("APPLY")}
          </Button>
        </Space>
      </>
    );
  };

  return (
    <>
      <div className="multi-select-filter-search-wrapper">
        <Row>
          <Col sm={24}>
            <Input.Search
              value={searchValue}
              onChange={handleSearchValue}
              disabled={loading}
            ></Input.Search>
          </Col>
          {loading && (
            <Col sm={24}>
              <Spin />
            </Col>
          )}
          {!loading && (
            <>
              <Col sm={24}>
                <Space direction="vertical">
                  {props.title && searchValue == "" &&displayOptions?.length>0 && (
                    <span className="option-title">{props.title}</span>
                  )}
                  <Checkbox.Group
                    className="options-wrapper"
                    onChange={handleOptionSelectionChange}
                    options={displayOptions}
                    value={selectedOptions}
                  ></Checkbox.Group>
                </Space>
              </Col>
              {props.isShowMoreFilterCount && remainCount > 0 && (
                <>
                  <Col sm={24}>
                    <Space direction="vertical">
                      <div className="more-wrapper">
                        <Popover
                          open={isMoreOptionsDrawerOpen}
                          placement="leftBottom"
                          content={moreFilterContent}
                          title={moreFilterTitleContent}
                          trigger={"click"}
                          overlayClassName="more-filter-popover-overlay"
                        >
                          <Button
                            type="link"
                            onClick={() => {
                              setIsMoreOptionDrawerOption(true);
                            }}
                            className="btn-underline"
                          >
                            {remainCount} More
                          </Button>
                        </Popover>
                      </div>
                    </Space>
                  </Col>
                </>
              )}
            </>
          )}
        </Row>
      </div>
    </>
  );
};
